import { Badge } from '@mui/material';

type TypeProps = {
  label: string;
  count: number;
  isActive: boolean;
};

export const TabLabel = ({ label, count, isActive }: TypeProps) => {
  return (
    <Badge
      badgeContent={count}
      color={isActive ? 'primary' : 'info'}
      max={99}
      sx={{
        '& .MuiBadge-colorInfo': {
          backgroundColor: 'grey',
        },
        '& .MuiBadge-badge': {
          margin: '-9px',
        },
      }}
    >
      {label}
    </Badge>
  );
};
